import { SeedPod } from "../../types";

export const SEED_PODS: SeedPod[] = [
  // --- SWEDISH FISHING & OUTDOOR (The Core) ---
  {
    id: "fiskekompisen",
    title: "Fiskekompisen",
    rssUrl: "https://fiskekompisen.se/feed/podcast/",
    language: "sv",
    country: "Sweden",
    state: "Skåne",
    categories: ["fishing", "outdoor", "nature"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://fiskekompisen.se/wp-content/uploads/2019/02/fiskekompisen-logo-ny.jpg",
  },
  {
    id: "gaddpodden",
    title: "Gäddpodden",
    rssUrl: "https://feed.podbean.com/gaddpodden/feed.xml",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["fishing", "pike", "sports"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/986429/Gaddpodden_logo_3000x3000b.jpg",
  },
  {
    id: "time-is-fish",
    title: "Time Is Fish Scandinavia",
    rssUrl: "https://feed.podbean.com/timeisfishpodcast/feed.xml",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["fishing", "interview"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/6463869/Time_is_Fish_logo_3000x3000.jpg",
  },
  {
    id: "swedish-anglers-rodpod",
    title: "Swedish Anglers RodPod",
    rssUrl: "https://swedishanglers.se/feed/podcast/",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["fishing", "carp", "specimen"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://swedishanglers.se/wp-content/uploads/2018/01/RodPod-Cover-Art.jpg",
  },
  {
    id: "jakt-fiske",
    title: "P4 Jakt & Fiske",
    rssUrl: "https://api.sr.se/api/rss/pod/21976",
    language: "sv",
    country: "Sweden",
    state: "Västerbotten",
    categories: ["hunting", "fishing", "outdoor"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://sverigesradio.se/sida/images/5421/2a486509-8e4d-4553-854d-6032e0000000.jpg",
  },
  {
    id: "flugfiskeradion",
    title: "Flugfiskeradion",
    rssUrl: "https://flugfiskeradion.se/feed/podcast/",
    language: "sv",
    country: "Sweden",
    state: "Västra Götaland",
    categories: ["fly-fishing", "outdoor"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://flugfiskeradion.se/wp-content/uploads/2014/03/Flugfiskeradion_logo_1400x1400.jpg",
  },
  {
    id: "fiske-for-alla",
    title: "Fiske för alla",
    rssUrl: "https://rss.acast.com/fiskeforalla",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["fishing", "tips", "gear"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://assets.pippa.io/shows/5d234b8c5f4853523255e064/1562602406673-9845e079d72567395688260295422365.jpeg",
  },

  // --- FINNISH PODCASTS ---

  // Fishing & Outdoor
  {
    id: "kalastajan-radio",
    title: "Kalastajan Radio",
    rssUrl: "https://www.kalastajankanava.fi/kalastajan-radio/feed/podcast/",
    language: "fi",
    country: "Finland",
    state: "Uusimaa",
    categories: ["fishing", "outdoor", "tips"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://www.kalastajankanava.fi/wp-content/uploads/2023/01/kalastajan-radio-logo.jpg",
  },

  {
    id: "explore-finland",
    title: "Explore Finland Radio Show",
    rssUrl: "https://feed.podbean.com/explorefinlandradioshow/feed.xml",
    language: "en",
    country: "Finland",
    state: "Uusimaa",
    categories: ["nature", "culture", "travel"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/965475/ExploreFinland_Logo_1400px.jpg",
  },

  // Society & Culture
  {
    id: "finnish-football",
    title: "The Finnish Football Show",
    rssUrl: "https://feed.podbean.com/FinnishFootballShow/feed.xml",
    language: "en",
    country: "Finland",
    state: "Uusimaa",
    categories: ["sports", "football", "soccer"],
    internalCategory: "sports",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/863667/FFS_Logo_3000.jpg",
  },
  {
    id: "very-finnish-problems",
    title: "Very Finnish Problems",
    rssUrl:
      "https://feeds.soundcloud.com/users/soundcloud:users:303727516/sounds.rss",
    language: "en",
    country: "Finland",
    state: "Uusimaa",
    categories: ["culture", "humor", "society"],
    internalCategory: "cooking_food_wine",
    source: "manual",
    imageUrl: "https://i1.sndcdn.com/avatars-000303727516-3ylbrl-original.jpg",
  },
  {
    id: "how-i-learned-finnish",
    title: "How I Learned Finnish",
    rssUrl: "https://feed.podbean.com/howilearnfinnish/feed.xml",
    language: "en",
    country: "Finland",
    state: "Uusimaa",
    categories: ["education", "language", "learning"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/11583827/How_I_Learned_Finnish_Logo_3000x3000_1_.jpg",
  },
  {
    id: "faraway-finland",
    title: "Faraway Finland Podcast",
    rssUrl: "https://feed.podbean.com/farawayfinland/feed.xml",
    language: "en",
    country: "Finland",
    state: "Uusimaa",
    categories: ["culture", "travel", "society"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/9838698/Faraway_Finland_Podcast_Logo.jpg",
  },
  {
    id: "random-finnish-lesson",
    title: "Random Finnish Lesson",
    rssUrl: "https://randomfinnishlesson.libsyn.com/rss",
    language: "fi",
    country: "Finland",
    state: "Uusimaa",
    categories: ["language", "education", "finnish"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://ssl-static.libsyn.com/p/assets/9/b/9/9/9b998c4f8dfd7e23/RandomFinnishLesson_Logo.jpg",
  },
  {
    id: "finnish-with-armin",
    title: "Finnish with Armin",
    rssUrl: "https://finnishwitharmin.libsyn.com/rss",
    language: "fi",
    country: "Finland",
    state: "Uusimaa",
    categories: ["language", "education", "culture"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://ssl-static.libsyn.com/p/assets/8/d/2/1/8d21739c0baf8b9f/FinnishWithArmin_Logo.jpg",
  },
  {
    id: "startalk-fi",
    title: "StartTalk Finland",
    rssUrl: "https://feed.podbean.com/startalkfinland/feed.xml",
    language: "en",
    country: "Finland",
    state: "Uusimaa",
    categories: ["business", "entrepreneurship", "tech"],
    internalCategory: "economy_business",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/6431847/StartTalk_Finland_Logo.png",
  },
  {
    id: "mitapelataan",
    title: "Mitä pelataan",
    rssUrl: "https://feed.podbean.com/mitapelataan/feed.xml",
    language: "fi",
    country: "Finland",
    state: "Uusimaa",
    categories: ["games", "board-games", "entertainment"],
    internalCategory: "sports",
    source: "manual",
    imageUrl:
      "https://pbcdn1.podbean.com/imglogo/image-logo/6789234/Mitapelataan_Logo.jpg",
  },
  {
    id: "yle-uutiset-selko",
    title: "YLE Uutiset selkosuomeksi",
    rssUrl: "https://feeds.yle.fi/areena/v1/series/1-4346112.rss",
    language: "fi",
    country: "Finland",
    state: "Uusimaa",
    categories: ["news", "current-affairs", "easy-finnish"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://images.cdn.yle.fi/image/upload/w_1200,h_1200,c_fill,f_auto,fl_lossy,q_auto:eco/13-3-10355761.jpg",
  },

  // --- INTERNATIONAL FISHING & OUTDOOR ---
  {
    id: "orvis-fly-fishing",
    title: "The Orvis Fly Fishing Guide",
    rssUrl: "https://feeds.simplecast.com/K2yV2yl-",
    language: "en",
    country: "United States",
    state: "Vermont",
    categories: ["fly-fishing", "outdoor", "education"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Podcasts116/v4/e3/3f/1e/e33f1e56-5003-9936-0c78-e65d283f9082/mza_13683268868365362867.jpg/1200x1200bb.jpg",
  },
  {
    id: "anchored-april-vokey",
    title: "Anchored with April Vokey",
    rssUrl: "https://anchored.libsyn.com/rss",
    language: "en",
    country: "Canada",
    state: "British Columbia",
    categories: ["outdoor", "fishing", "hunting"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://ssl-static.libsyn.com/p/assets/6/8/6/c/686c947760922613/Anchored_Podcast_Cover_Art.jpg",
  },
  // --- OUTDOOR & ADVENTURE ---
  {
    id: "446951",
    title: "The MeatEater Podcast",
    rssUrl:
      "https://www.omnycontent.com/d/playlist/e73c998e-6e60-432f-8610-ae210140c5b1/63aba8bc-2dc8-4f89-807a-ae280065a7cd/3892b9a1-a960-4f9e-bee7-ae280065a7db/podcast.rss",
    language: "en",
    country: "United States",
    state: "Montana",
    categories: ["outdoor", "hunting", "nature"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://www.omnycontent.com/d/playlist/e73c998e-6e60-432f-8610-ae210140c5b1/63aba8bc-2dc8-4f89-807a-ae280065a7cd/3892b9a1-a960-4f9e-bee7-ae280065a7db/image.jpg?t=1643091011&size=Large",
  },
  {
    id: "wet-fly-swing",
    title: "Wet Fly Swing Fly Fishing",
    rssUrl: "https://wetflyswing.com/feed/podcast",
    language: "en",
    country: "United States",
    state: "Oregon",
    categories: ["fly-fishing", "outdoor"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Podcasts115/v4/9b/18/92/9b189251-c453-8342-3886-682a754c5808/mza_16944078764693656346.jpg/1200x1200bb.jpg",
  },
  {
    id: "destination-angler",
    title: "The Destination Angler",
    rssUrl: "https://destinationangler.libsyn.com/rss",
    language: "en",
    country: "United States",
    state: "New York",
    categories: ["travel", "fishing"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://ssl-static.libsyn.com/p/assets/8/f/3/8/8f38b0c902156036/Destination_Angler_Podcast_Cover_Art.jpg",
  },
  {
    id: "captains-collective",
    title: "Captains Collective",
    rssUrl: "https://feeds.buzzsprout.com/265863.rss",
    language: "en",
    country: "United States",
    state: "Florida",
    categories: ["fishing", "sailing", "interview"],
    internalCategory: "fishing_outdoor",
    source: "manual",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Podcasts115/v4/45/43/86/45438609-8259-9729-1630-52754560070e/mza_6534664829823809477.jpg/1200x1200bb.jpg",
  },

  // --- SWEDISH TOP CHARTS (The Essentials) ---
  {
    id: "ursakta",
    title: "Ursäkta",
    rssUrl: "https://feeds.acast.com/public/shows/60655359a35e723a1a5b487b",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["comedy", "culture"],
    internalCategory: "sports", // Grouping with entertainment
    source: "manual",
    imageUrl:
      "https://assets.pippa.io/shows/5fa947a3c373464019d98523/1605017737629-3f748056807941768798406292187795.jpeg",
  },

  {
    id: "p3-historia",
    title: "P3 Historia",
    rssUrl: "https://api.sr.se/api/rss/pod/4663",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["history", "education"],
    internalCategory: "tech_ai_software", // Educational
    source: "manual",
    imageUrl: "",
  },
  {
    id: "fordomspodden",
    title: "Fördomspodden",
    rssUrl: "https://rss.acast.com/fordomspodden",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["comedy", "interview"],
    internalCategory: "sports",
    source: "manual",
    imageUrl:
      "https://assets.pippa.io/shows/5c5996d071582a2343705146/1550664058518-00350426533372555542732580322785.jpeg",
  },

  {
    id: "alex-sigge",
    title: "Alex & Sigges podcast",
    rssUrl: "https://feed.pod.space/alexosigge",
    language: "sv",
    country: "Sweden",
    state: "Stockholm",
    categories: ["comedy", "culture"],
    internalCategory: "sports",
    source: "manual",
    imageUrl:
      "https://assets.pippa.io/shows/5c5996d671582a234370514c/1550664153564-54655374207229866532525740576536.jpeg",
  },

  // --- GLOBAL HITS ---
  {
    id: "joe-rogan",
    title: "The Joe Rogan Experience",
    rssUrl: "https://feeds.megaphone.fm/JRE",
    language: "en",
    country: "United States",
    state: "Texas",
    categories: ["culture", "comedy", "interview"],
    internalCategory: "sports",
    source: "manual",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Podcasts113/v4/bf/44/ce/bf44ce50-b429-11eb-b4b1-a3d2e67ae662/mza_17208889720442347690.jpg/1200x1200bb.jpg",
  },
  {
    id: "6943047",
    title: "Huberman Lab",
    rssUrl: "https://feeds.megaphone.fm/hubermanlab",
    language: "en",
    country: "United States",
    state: "California",
    categories: ["science", "health", "education"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://megaphone.imgix.net/podcasts/042e6144-725e-11ec-a75d-c38f702aecad/image/ee4f0b7b466ca35620792970d9bce2d2.jpg?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    id: "739525",
    title: "The Tim Ferriss Show",
    rssUrl: "https://rss.art19.com/tim-ferriss-show",
    language: "en",
    country: "United States",
    state: "Texas",
    categories: ["business", "interview", "lifestyle"],
    internalCategory: "economy_business",
    source: "manual",
    imageUrl:
      "https://content.production.cdn.art19.com/images/69/10/10/fb/691010fb-625e-4abe-993c-a57228b28dbe/91cb53ae0d5dbb379b9dffecf0a772593891d0d09bbe6d90ee746edbdb79e3ec75584f2ceb8260e9f675a90c05419b9b99842a76905b686f0f51c1a9d3e227ab.jpeg",
  },
  {
    id: "947138",
    title: "Waveform: The MKBHD Podcast",
    rssUrl: "https://feeds.megaphone.fm/STU4418364045",
    language: "en",
    country: "United States",
    state: "New Jersey",
    categories: ["technology", "gadgets", "interview"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://megaphone.imgix.net/podcasts/ae6237e6-7e71-11e9-9c4d-3b02b0eab47c/image/21_VMPN_011_Waveform_Social_3000x3000.png?ixlib=rails-4.3.1&max-w=3000&max-h=3000&fit=crop&auto=format,compress",
  },
  {
    id: "lex-fridman",
    title: "Lex Fridman Podcast",
    rssUrl: "https://lexfridman.com/feed/podcast/",
    language: "en",
    country: "United States",
    state: "Texas",
    categories: ["technology", "ai", "science"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Podcasts125/v4/9e/6c/c6/9e6cc693-2b1b-0d74-0833-7f99c8062813/mza_4900126063475463597.jpg/1200x1200bb.jpg",
  },
  {
    id: "1015378",
    title: "All-In Podcast",
    rssUrl: "http://allinchamathjason.libsyn.com/rss",
    language: "en",
    country: "United States",
    state: "California",
    categories: ["business", "technology", "politics"],
    internalCategory: "economy_business",
    source: "manual",
    imageUrl:
      "https://static.libsyn.com/p/assets/a/9/c/b/a9cb4d1dadb1ea21/all-in_logo.png",
  },

  // --- DAN CARLIN ---
  {
    id: "hardcore-history",
    title: "Dan Carlin's Hardcore History",
    rssUrl: "https://feeds.feedburner.com/dancarlin/history",
    language: "en",
    country: "United States",
    state: "Oregon",
    categories: ["history", "education", "documentary"],
    internalCategory: "tech_ai_software", // Educational
    source: "manual",
    imageUrl: "https://www.dancarlin.com/graphics/DC_HH_iTunes.jpg",
  },
  {
    id: "common-sense-carlin",
    title: "Common Sense with Dan Carlin",
    rssUrl: "https://feeds.feedburner.com/dancarlin/commonsense",
    language: "en",
    country: "United States",
    state: "Oregon",
    categories: ["politics", "current-affairs", "commentary"],
    internalCategory: "economy_business",
    source: "manual",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Podcasts125/v4/da/7d/31/da7d3146-6c9f-db2f-f3fa-e84e29b7c4d8/mza_15282261412788704264.jpg/1200x1200bb.jpg",
  },

  // --- CREATIVE & MUSIC ---
  {
    id: "387129",
    title: "99% Invisible",
    rssUrl: "https://feeds.simplecast.com/BqbsxVfO",
    language: "en",
    country: "United States",
    state: "California",
    categories: ["architecture", "design", "culture"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://image.simplecastcdn.com/images/8436e3c1-2479-4466-ac48-fa58259960bb/a6d5b177-ab5d-430d-b3f2-b393a09d8101/3000x3000/sxm-cover-99percentinvisible-r2025-3000x3000-final.jpg?aid=rss_feed",
  },

  // --- AI & TECH PODCASTS ---
  {
    id: "6058902",
    title: "Latent Space",
    rssUrl: "https://rss.flightcast.com/vgnxzgiwwzwke85ym53fjnzu.xml",
    language: "en",
    country: "United States",
    state: "California",
    categories: ["ai", "technology", "engineering"],
    internalCategory: "tech_ai_software",
    source: "manual",
    imageUrl:
      "https://assets.flightcast.com/static/01K4D8FDXRRRRZG0EBGNDF3SD3.jpg",
  },
];
